import React, { Fragment, useState } from 'react';

import DesignEditor from '../../../components/global/DesignEditor';
import DesignEditorHeader, {
  DesignEditorHeaderCenterSlot,
  DesignEditorHeaderLeftSlot,
  DesignEditorHeaderRightSlot,
} from '../../../components/global/DesignEditor/components/DesignEditorHeader';
import DesignEditorControls, {
  DesignEditorPrimaryControls,
  DesignEditorSecondaryControls,
  DesignEditorAuxiliaryControlBar,
} from '../../../components/global/DesignEditor/components/DesignEditorControls';
import DesignEditorPreviewPane from '../../../components/global/DesignEditor/components/DesignEditorPreviewPane';
import SizingIcon from '../../../components/icons/SizingIcon';
import DesignEditorPrimaryControlButton from '../../../components/global/DesignEditor/components/DesignEditorControls/components/DesignEditorPrimaryControlButton';
import MountingIcon from '../../../components/icons/MountingIcon';
import TemplatesIcon from '../../../components/icons/TemplatesIcon';
import Button from '../../../components/global/Button';
import DesignerViewSecondaryA from './DesignerViewSecondaryA';
import DesignerViewSecondaryB from './DesignerViewSecondaryB';
import DesignerViewSecondaryC from './DesignerViewSecondaryC';
import DesignEditorPreviewContent from '../../../components/global/DesignEditor/components/DesignEditorPreviewPane/DesignEditorPreviewContent';
import FormGroup from '../../../components/global/FormGroup';

const DesignerView = () => {
  const CONTROL_PANE = {
    A: 'a',
    B: 'b',
    C: 'c',
  };
  const [activeControlPane, setActiveControlPane] = useState(CONTROL_PANE.A);

  return (
    <DesignEditor>
      <DesignEditorHeader>
        <DesignEditorHeaderLeftSlot>Left</DesignEditorHeaderLeftSlot>
        <DesignEditorHeaderCenterSlot>
          <h3 className="design-editor-header-title">Title</h3>
        </DesignEditorHeaderCenterSlot>
        <DesignEditorHeaderRightSlot>
          <Button btnSize="sm">Do something</Button>
        </DesignEditorHeaderRightSlot>
      </DesignEditorHeader>

      <DesignEditorControls>
        <DesignEditorPrimaryControls>
          <DesignEditorPrimaryControlButton
            active={activeControlPane === CONTROL_PANE.A}
            icon={<SizingIcon />}
            title="Panel A"
            onClick={() => {
              setActiveControlPane(CONTROL_PANE.A);
            }}
          />
          <DesignEditorPrimaryControlButton
            active={activeControlPane === CONTROL_PANE.B}
            icon={<MountingIcon />}
            title="Panel B"
            onClick={() => {
              setActiveControlPane(CONTROL_PANE.B);
            }}
          />
          <DesignEditorPrimaryControlButton
            active={activeControlPane === CONTROL_PANE.C}
            icon={<TemplatesIcon />}
            title="Panel C"
            onClick={() => {
              setActiveControlPane(CONTROL_PANE.C);
            }}
          />
        </DesignEditorPrimaryControls>

        <DesignEditorSecondaryControls>
          <DesignerViewSecondaryA
            visible={activeControlPane === CONTROL_PANE.A}
          />
          <DesignerViewSecondaryB
            visible={activeControlPane === CONTROL_PANE.B}
          />
          <DesignerViewSecondaryC
            visible={activeControlPane === CONTROL_PANE.C}
          />
        </DesignEditorSecondaryControls>
      </DesignEditorControls>

      <DesignEditorPreviewPane>
        <DesignEditorAuxiliaryControlBar
          contentLeft={
            <Fragment>
              <p className="mr-1 text-sm">Whatever</p>
              <FormGroup
                id="random-form-control-1"
                label="Whatever 1"
                labelSrOnly
                size="sm"
                placeholder="Type something..."
              />
            </Fragment>
          }
          contentRight={
            <Fragment>
              <FormGroup
                id="random-form-control-2"
                label="Whatever 2"
                labelSrOnly
                size="sm"
                placeholder="Type something..."
                className="mr-1"
              />
              <Button btnStyle="secondary" btnSize="sm">
                Some action
              </Button>
            </Fragment>
          }
        />

        <DesignEditorPreviewContent>
          Your main screen here (can be anything)
        </DesignEditorPreviewContent>
      </DesignEditorPreviewPane>
    </DesignEditor>
  );
};

export default DesignerView;
